import React from 'react';
import { motion } from 'framer-motion';
import { FaStethoscope, FaPaintBrush, FaUtensils, FaGraduationCap, FaShoppingBag, FaHome, FaRocket, FaCamera } from 'react-icons/fa';

const audiences = [
  { icon: FaStethoscope, name: 'Healthcare', subtitle: 'Doctors, Clinics & Hospitals', gradient: 'from-cyan-400 to-blue-500' },
  { icon: FaPaintBrush, name: 'Beauty & Wellness', subtitle: 'Salons, MUAs & Spas', gradient: 'from-pink-400 to-purple-500' },
  { icon: FaUtensils, name: 'Food & Hospitality', subtitle: 'Restaurants & Cloud Kitchens', gradient: 'from-orange-400 to-red-500' },
  { icon: FaGraduationCap, name: 'Education', subtitle: 'Coaches, Institutes & EdTech', gradient: 'from-yellow-400 to-orange-500' },
  { icon: FaShoppingBag, name: 'Fashion & Retail', subtitle: 'Boutiques & E-Commerce', gradient: 'from-purple-400 to-pink-500' },
  { icon: FaHome, name: 'Real Estate', subtitle: 'Agents & Builders', gradient: 'from-green-400 to-emerald-500' },
  { icon: FaCamera, name: 'Creators & Influencers', subtitle: 'Personal Brands & Studios', gradient: 'from-rose-400 to-orange-500' },
  { icon: FaRocket, name: 'Startups & Tech', subtitle: 'Local Businesses & SaaS', gradient: 'from-blue-400 to-indigo-500' },
];

export default function AudienceStrip() {
  return (
    <section className="py-32 px-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-cyan-500/5 to-transparent pointer-events-none" />
      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} className="text-center mb-20">
          <motion.span whileHover={{ scale: 1.05 }}
            className="inline-block px-6 py-2 bg-gradient-to-r from-cyan-500/10 to-orange-500/10 border border-cyan-500/20 rounded-full text-sm font-semibold text-cyan-400 mb-6 backdrop-blur-sm">
            Industries We Serve
          </motion.span>
          <h2 className="text-5xl md:text-7xl font-black mb-6">
            Who We <span className="bg-gradient-to-r from-cyan-400 to-orange-500 bg-clip-text text-transparent">Empower</span>
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto leading-relaxed">
            From healthcare to fashion, we deliver tailored digital strategies that make your brand visible and grow online
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {audiences.map((a, i) => (
            <motion.div key={a.name}
              initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.1, type: 'spring', stiffness: 100 }}
              whileHover={{ y: -12, scale: 1.02 }} className="relative group cursor-pointer">
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/0 to-orange-500/0 group-hover:from-cyan-500/10 group-hover:to-orange-500/10 rounded-3xl transition-all duration-500 blur-xl" />
              <div className="relative bg-gradient-to-br from-gray-50/80 dark:from-gray-900/80 to-white/80 dark:to-black/80 p-8 rounded-3xl border border-gray-200 dark:border-gray-800 group-hover:border-cyan-500/40 transition-all duration-500 backdrop-blur-md overflow-hidden h-full">
                <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent"
                  initial={{ x: '-100%' }} whileHover={{ x: '100%' }} transition={{ duration: 0.6 }} />
                <div className={`w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br ${a.gradient} flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-2xl`}>
                  <a.icon className="text-4xl text-gray-900 dark:text-white" />
                </div>
                <h3 className="text-xl font-bold mb-2 text-center group-hover:text-cyan-400 transition-colors">{a.name}</h3>
                <p className="text-sm text-gray-500 text-center font-medium">{a.subtitle}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
